import './title.scss';




// WEBPACK FOOTER //
// ./resources/views/partials/products_type/title/title.js